module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-3-photo-4-6b9756e00d9fb7b8ee7f78af52297a72.webp";